import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { staffApi } from '@/lib/staffApi';
import { CustomerSubmissionModal } from '@/components/CustomerSubmissionModal';

export function FormReviews() {
    const [data, setData] = useState(null), [error, setError] = useState('');
    const [offset, setOffset] = useState(0), [selected, setSelected] = useState(null);
    const [busy, setBusy] = useState(false);
    const load = useCallback(() => {
        setError(''); setData(null);
        staffApi.listFormReviews(offset).then(setData).catch(e => setError(e.message || 'Could not load forms.'));
    }, [offset]);
    useEffect(load, [load]);
    const review = async () => {
        if (busy) return;
        setBusy(true);
        try { await staffApi.reviewSubmission(selected); setSelected(null); load(); }
        catch (e) { setSelected(null); setError(e.message || 'Could not mark form as read.'); }
        finally { setBusy(false); }
    };
    return <section className="space-y-4">
        <h1 className="font-serif text-3xl">Forms to review</h1>
        <p>Read completed forms and add your practitioner signature. Forms needing your signature stay here even after being marked as read.</p>
        <button onClick={load} className="text-gold">Refresh</button>
        {error && <p role="alert">{error}</p>}
        {!data && !error && <p>Loading forms…</p>}
        {data?.submissions.length === 0 && <p>No forms are waiting to be reviewed.</p>}
        {data?.submissions.map(s => <article key={s.id} className="rounded-2xl glass p-5 space-y-2 min-w-0">
            <h2 className="text-lg text-white break-words">{s.customer_name}</h2>
            <p className="text-white/80 break-words">{s.title_snapshot}</p>
            {s.practitioner_signature_pending && <p className="text-gold">Practitioner signature needed</p>}
            <p className="text-sm text-white/60">Received {new Date(s.submitted_at).toLocaleString('en-GB')}</p>
            <div className="flex flex-wrap gap-4 items-center">
                <button onClick={() => setSelected(s.id)} className="rounded-full bg-gold text-navy px-4 py-2">View form</button>
                {s.appointment_id && <Link className="text-gold" to={`/staff/appointments/${s.appointment_id}`}>View appointment</Link>}
            </div>
        </article>)}
        <div className="flex gap-4">
            {offset > 0 && <button onClick={() => setOffset(Math.max(0, offset - 30))}>Previous</button>}
            {data && offset + 30 < data.total && <button onClick={() => setOffset(offset + 30)}>Next</button>}
        </div>
        {selected && <CustomerSubmissionModal id={selected} onClose={() => {setSelected(null);load();}} onReviewed={review} />}
    </section>;
}
